import { NavLink } from "react-router-dom";
import AdventureImg from "../../../assets/bg-ropeswing.png";
import Reveal from "../../../shared/design/Reveal";

const WhyBand = () => {
  return (
    <Reveal className="mx-auto mt-14 max-w-[1320px] px-6 md:px-12">
      <div className="relative h-[440px] overflow-hidden rounded-[26px]">
        <img
          src={AdventureImg}
          alt="Adventure"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[rgba(19,58,69,0.85)] to-[rgba(19,58,69,0.15)]" />
        <div className="relative flex h-full max-w-[560px] flex-col justify-center p-8 md:p-14">
          <div className="mb-4 font-mono text-[12.5px] tracking-[0.12em] text-primary-500">
            WHY WANDER
          </div>
          <h2 className="mb-[18px] font-serif text-[32px] font-normal leading-[1.1] text-white md:text-[40px]">
            Small groups. Real guides.
            <br />
            No two days the same.
          </h2>
          <p className="mb-[26px] text-[16.5px] leading-relaxed text-[#d6e0dc]">
            Max 12 travelers. Local experts who know which trail to take when
            the crowds arrive. We handle the logistics so you can chase the
            light.
          </p>
          <NavLink
            to="/people"
            className="self-start rounded-full bg-primary-500 px-[26px] py-3.5 text-[15px] font-bold text-ink transition-colors hover:bg-primary-300"
          >
            Our promise →
          </NavLink>
        </div>
      </div>
    </Reveal>
  );
};

export default WhyBand;
